import React, { useState, useMemo, useRef, useEffect } from "react";
import "./PartyScreen.css";
import SelectPopup from "./SelectPopup";
const API = "http://103.79.74.237:8081/api/party";

export default function PartyScreen() {
const [mobileTab, setMobileTab] = useState("list");
const isMobile = window.innerWidth <= 768;
  const [parties, setParties] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [editId, setEditId] = useState(null);

const [areaList, setAreaList] = useState([]);

const [mounted, setMounted] = useState(false);
const [formKey, setFormKey] = useState(Date.now());
const [nameError, setNameError] = useState("");


const [popupSearch,setPopupSearch] = useState("");
const [activePopupIndex,setActivePopupIndex] = useState(0);

const deliveryModes = ["Road","Courier","Pickup","Transport"];

const custTypes = ["Customer","Supplier"];

const prLists = ["Custom","Regular"];

const idProofs = ["Aadhaar","PAN","Voter ID"];


  const initialForm = {
  name: "",
  address: "",
  deliAddress: "",
  place: "",
  deliPlace: "",
  area: "",
  state: "",
  gstin: "",
  contactPerson: "",
  contactNo: "",
  pin: "",
  deliveryMode: "",
  idProof: "Aadhaar",
  idNo: "",
  custType: "Customer",
  prList: "Custom",
  mobile: "",
  openBal: "",
  creditDays: "0",
  creditLimit: ""
};

const newBtnRef = useRef(null);
const saveBtnRef = useRef(null);
const updateBtnRef = useRef(null);
const deleteBtnRef = useRef(null);
const [gstError, setGstError] = useState(false);

  const [form, setForm] = useState(initialForm);

  const inputsRef = useRef({});
  const listRowRefs = useRef([]);
const fieldOrder = [
  "name",
  "place",
  "address",
  "deliAddress",
  "deliPlace",
  "area",
  "state",
  "gstin",
  "contactPerson",
  "contactNo",
  "pin",
  "deliveryMode",
  "idProof",
  "idNo",
  "custType",
  "prList",
  "mobile",
  "openBal",
  "creditDays",
  "creditLimit"
];
const [popup,setPopup] = useState({
open:false,
field:"",
title:"",
options:[],
allowAdd:false
});

const stateCodes = {
  "Andaman and Nicobar Islands": "35",
  "Andhra Pradesh": "37",
  "Arunachal Pradesh": "12",
  "Assam": "18",
  "Bihar": "10",
  "Chandigarh": "04",
  "Chhattisgarh": "22",
  "Dadra and Nagar Haveli": "26",
  "Daman and Diu": "25",
  "Delhi": "07",
  "Goa": "30",
  "Gujarat": "24",
  "Haryana": "06",
  "Himachal Pradesh": "02",
  "Jammu and Kashmir": "01",
  "Jharkhand": "20",
  "Karnataka": "29",
  "Kerala": "32",
  "Ladakh": "38",
  "Lakshadweep": "31",
  "Madhya Pradesh": "23",
  "Maharashtra": "27",
  "Manipur": "14",
  "Meghalaya": "17",
  "Mizoram": "15",
  "Nagaland": "13",
  "Odisha": "21",
  "Puducherry": "34",
  "Punjab": "03",
  "Rajasthan": "08",
  "Sikkim": "11",
  "Tamil Nadu": "33",
  "Telangana": "36",
  "Tripura": "16",
  "Uttar Pradesh": "09",
  "Uttarakhand": "05",
  "West Bengal": "19"
};
const states = Object.keys(stateCodes).sort((a, b) => a.localeCompare(b));




useEffect(() => {
  setMounted(true);
}, []);

useEffect(() => {
  fetch(`${API}/areas`)
    .then(res => res.json())
    .then(data => setAreaList(data || []));
}, []);

const checkDuplicateName = async (name) => {
  if (!name.trim()) return false;

  const res = await fetch(
    `${API}/exists?name=${encodeURIComponent(name)}`
  );

  const exists = await res.json();

  // If editing same record, ignore
  if (exists && !editId) {
    setNameError("Party name already exists");
    return true;
  }

  setNameError("");
  return false;
};
const openPopup = (field,title,options,allowAdd=false)=>{
setPopup({
open:true,
field,
title,
options,
allowAdd
});
};

const handleKeyNavigation = async (e, currentField) => {
  const index = fieldOrder.indexOf(currentField);

  if (e.key === "Enter") {
  e.preventDefault();

  // 🔥 Check duplicate before leaving name field
  if (currentField === "name") {
    const res = await fetch(
      `${API}/exists?name=${encodeURIComponent(form.name)}`
    );
    const exists = await res.json();

    // If inserting new (not updating)
    if (exists && !editId) {
      setNameError("Party name already exists");
      inputsRef.current["name"]?.focus();
      return; // ❌ stop navigation
    }
  }

  if (index < fieldOrder.length - 1) {
    const nextField = fieldOrder[index + 1];
    inputsRef.current[nextField]?.focus();
  } else {
    saveBtnRef.current?.focus();
  }
}
  // ARROW DOWN → next field
  if (e.key === "ArrowDown") {
    e.preventDefault();
    if (index < fieldOrder.length - 1) {
      const nextField = fieldOrder[index + 1];
      inputsRef.current[nextField]?.focus();
    }
  }

  // ARROW UP → previous field
  if (e.key === "ArrowUp") {
    e.preventDefault();
    if (index > 0) {
      const prevField = fieldOrder[index - 1];
      inputsRef.current[prevField]?.focus();
    }
  }
};

const handleButtonNavigation = (e, current) => {
  if (e.key === "ArrowRight") {
    e.preventDefault();
    if (current === "new") saveBtnRef.current?.focus();
    if (current === "save") updateBtnRef.current?.focus();
    if (current === "update") deleteBtnRef.current?.focus();
  }

  if (e.key === "ArrowLeft") {
    e.preventDefault();
    if (current === "delete") updateBtnRef.current?.focus();
    if (current === "update") saveBtnRef.current?.focus();
    if (current === "save") newBtnRef.current?.focus();
  }

  if (e.key === "Enter") {
    e.preventDefault();
    if (current === "new") onNew();
    if (current === "save") onSave();
    if (current === "update") onUpdate();
    if (current === "delete") onDelete();
  }
};

  /* ---------------- LOAD PARTIES (DB) ---------------- */
  const loadParties = async () => {
    try {
      const res = await fetch(API);
      const data = await res.json();
      setParties(data);
    } catch (err) {
      console.error("Failed to load parties", err);
    }
  };

  useEffect(() => {
    loadParties();
  }, []);

  /* ---------------- SEARCH ---------------- */
  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    if (!q) return parties;
    return parties.filter(p =>
      p.partyName.toLowerCase().includes(q) ||
      (p.place || "").toLowerCase().includes(q) ||
      (p.mobileNo || "").includes(q)
    );
  }, [search, parties]);

  useEffect(() => {
    if (filtered.length === 0) setSelectedIndex(-1);
    else if (selectedIndex >= filtered.length)
      setSelectedIndex(filtered.length - 1);
  }, [filtered, selectedIndex]);

  /* ---------------- HELPERS ---------------- */
  const updateField = (k, v) => {
    setForm(prev => ({ ...prev, [k]: v }));
  };

  /* ---------------- SELECT (EDIT MODE) ---------------- */
  const handleSelect = party => {
    setEditId(party.id);
    setForm({
      name: party.partyName || "",
      address: party.address || "",
      deliAddress: party.deliAddress || "",
      place: party.place || "",
      deliPlace: party.deliPlace || "",
      area: party.area || "",
      state: party.state || "",
      gstin: party.gstin || "",
      idProof: party.idProof || "Aadhaar",
      idNo: party.idNo || "",
      custType: party.custType || "Customer",
      prList: party.prList || "Custom",
      mobile: party.mobileNo || "",
      openBal: party.openBal || "",
      creditDays: party.creditDays || "0",
      creditLimit: party.creditLimit || ""
    });
  };

  /* ---------------- SAVE (INSERT) ---------------- */
 const onSave = async () => {

  // 1️⃣ Party name mandatory
  if (!form.name.trim()) {
    alert("Party Name required");
    return;
  }

  // 2️⃣ GST validation (ONLY if GST entered)
  if (form.gstin && !validateGSTIN(form.gstin)) {
    alert("Invalid GSTIN format");
    return;
  }

  const payload = {
    partyName: form.name,
    address: form.address,
    deliAddress: form.deliAddress,
    place: form.place,
    deliPlace: form.deliPlace,
    area: form.area,
    state: form.state,
    gstin: form.gstin,
    idProof: form.idProof,
    idNo: form.idNo,
    custType: form.custType,
    prList: form.prList,
    mobileNo: form.mobile,
    openBal: Number(form.openBal || 0),
    creditDays: Number(form.creditDays || 0),
    creditLimit: Number(form.creditLimit || 0)
  };

const res = await fetch(API, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload)
});

if (!res.ok) {
  const msg = await res.text();
  alert(msg);
  return;
}

  alert("Party saved");
  setForm(initialForm);
  setEditId(null);
  loadParties();
};


  /* ---------------- UPDATE ---------------- */
  const onUpdate = async () => {
    if (!editId) {
      alert("Select a party to update");
      return;
    }

 const payload = {
  partyName: form.name,
  address: form.address,
  deliAddress: form.deliAddress,
  place: form.place,
  deliPlace: form.deliPlace,
  area: form.area,
  state: form.state,
  gstin: form.gstin,
  contactPerson: form.contactPerson,
  contactNo: form.contactNo,
  pin: form.pin,
  deliveryMode: form.deliveryMode,
  idProof: form.idProof,
  idNo: form.idNo,
  custType: form.custType,
  prList: form.prList,
  mobileNo: form.mobile,
  openBal: Number(form.openBal || 0),
  creditDays: Number(form.creditDays || 0),
  creditLimit: Number(form.creditLimit || 0)
};

const response = await fetch(`${API}/${editId}`, {
  method: "PUT",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload)
});

if (!response.ok) {
  const errorText = await response.text();
  alert(errorText);
  return;
}

alert("Party updated");
setForm(initialForm);
setEditId(null);
loadParties();
  };

  /* ---------------- DELETE ---------------- */
  const onDelete = async () => {
    if (!editId) return;
    if (!window.confirm("Delete party?")) return;

    await fetch(`${API}/${editId}`, { method: "DELETE" });

    setForm(initialForm);
    setEditId(null);
    loadParties();
  };

  /* ---------------- NEW ---------------- */
const onNew = () => {
  setForm(initialForm);
  setEditId(null);
  setSelectedIndex(-1);
  setFormKey(Date.now());
};

const openNewPartyMobile = () => {
  onNew();
  setMobileTab("entry");
};

  const validateGSTIN = (gstin) => {
  const gstRegex =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;

  return gstRegex.test(gstin);
};





  /* ---------------- UI ---------------- */
  return (
    <div className="party-window">
      <div className="party-title">PARTY ADDING</div>

  <div className={`party-content ${mobileTab === "entry" ? "show-entry" : "show-list"}`}>
        {/* LEFT FORM */}
      <div className="party-left-compact">
<div className="left-form-body">
            
              <div className="inv-card-header">Party Entry</div>
            <div className="form-grid">
         
            <label>Party Name</label>

<div className="input-wrapper">
<input
  ref={el => inputsRef.current["name"] = el}
  name="party_name_unique_erp_001"
  value={form.name}
  onChange={e => {
    if (editId) return;
    updateField("name", e.target.value);
    setNameError("");
  }}
  onKeyDown={e => handleKeyNavigation(e, "name")}
  autoComplete="off"
  readOnly={!!editId}
  className={nameError ? "input-error" : editId ? "input-readonly" : ""}
/>

  {nameError && (
    <span className="field-error">{nameError}</span>
  )}
</div>
      <label>Place</label>
              <input  ref={el => inputsRef.current["place"] = el}  name="place_unique_erp_002"value={form.place} onChange={e => updateField("place", e.target.value)}   onKeyDown={e => handleKeyNavigation(e, "place")} autoComplete="off"/>

              <div className="full-row">
                <label>Address</label>
                <input  ref={el => inputsRef.current["address"] = el}  name="address_unique_erp_003"value={form.address} onChange={e => updateField("address", e.target.value)}   onKeyDown={e => handleKeyNavigation(e, "address")} autoComplete="off"/>
              </div>

              <div className="full-row">
                <label>Deli. Address</label>
                <input  ref={el => inputsRef.current["deliAddress"] = el}  name="deli_address_unique_erp_004"value={form.deliAddress} onChange={e => updateField("deliAddress", e.target.value)}   onKeyDown={e => handleKeyNavigation(e, "deliAddress")} autoComplete="off"/>
              </div>

              <label>Deli. Place</label>
              <input  ref={el => inputsRef.current["deliPlace"] = el}  name="deli_place_unique_erp_005"value={form.deliPlace} onChange={e => updateField("deliPlace", e.target.value)}   onKeyDown={e => handleKeyNavigation(e, "deliPlace")} autoComplete="off"/>

              <label>Area</label>
             <input
  ref={el => inputsRef.current["area"] = el}
   name="area_unique_erp_006"
  value={form.area}
 onClick={()=>openPopup("area","Select Area",areaList,true)}
  onKeyDown={e => handleKeyNavigation(e, "area")}
  autoComplete="off"
/>

<label>State</label>

<input
ref={el => inputsRef.current["state"] = el}
value={form.state}
placeholder="Select State"
readOnly
onClick={()=>openPopup("state","Select State",states,false)}
onKeyDown={e => handleKeyNavigation(e, "state")}
/>
              <label>GSTIN</label>

<div className="gst-wrapper">
  {/* Locked Prefix */}
  <input
    className="gst-prefix"
    value={stateCodes[form.state] || ""}
    readOnly
  />

  {/* Remaining 13 digits */}
  <input
    className="gst-body"
    name="gstin_unique_erp_007"
    value={form.gstin.slice(2)}
    maxLength={13}
    autoComplete="off"
    onChange={e => {
      const body = e.target.value.toUpperCase();
      const prefix = stateCodes[form.state] || "";
      const fullGST = prefix + body;

      updateField("gstin", fullGST);

      if (fullGST.length === 15) {
        setGstError(!validateGSTIN(fullGST));
      } else {
        setGstError(false);
      }
    }}
  />
</div>


<label>Contact Person</label>
<input
  ref={el => inputsRef.current["contactPerson"] = el}
   name="contact_person_unique_erp_008"
  value={form.contactPerson}
  onChange={e => updateField("contactPerson", e.target.value)}
  onKeyDown={e => handleKeyNavigation(e, "contactPerson")}
  autoComplete="off"
/>

<label>Contact No</label>
<input
  ref={el => inputsRef.current["contactNo"] = el}
   name="contact_no_unique_erp_009"
  value={form.contactNo}
  onChange={e => updateField("contactNo", e.target.value)}
  onKeyDown={e => handleKeyNavigation(e, "contactNo")}
  autoComplete="off"
/>

<label>PIN</label>
<input
  ref={el => inputsRef.current["pin"] = el}
   name="pin_unique_erp_010"
  value={form.pin}
  onChange={e => updateField("pin", e.target.value)}
  onKeyDown={e => handleKeyNavigation(e, "pin")}
  autoComplete="off"
/>

<label>Delivery Mode</label>
<input
ref={el => inputsRef.current["deliveryMode"] = el}
value={form.deliveryMode}
placeholder="Select Delivery Mode"
readOnly
onClick={()=>openPopup("deliveryMode","Delivery Mode",deliveryModes,false)}
  onKeyDown={e => handleKeyNavigation(e, "deliveryMode")}
  autoComplete="off"
/>

              {form.gstin.length !== 15 && (
  <>
    <label>ID Proof</label>
  <input
ref={el => inputsRef.current["idProof"] = el}
value={form.idProof}
placeholder="Select ID Proof"
readOnly
onClick={()=>openPopup("idProof","ID Proof",idProofs,false)}
  onKeyDown={e => handleKeyNavigation(e, "idProof")}
  autoComplete="off"

/>
     
   

    <label>ID No</label>
    <input
      ref={el => inputsRef.current["idNo"] = el}
       name="id_no_unique_erp_013"
      value={form.idNo}
      onChange={e => updateField("idNo", e.target.value)}
      onKeyDown={e => handleKeyNavigation(e, "idNo")}
      autoComplete="off"
    />
  </>
)}


              <label>Cust Type</label>
             <input
ref={el => inputsRef.current["custType"] = el}
value={form.custType}
placeholder="Select Customer Type"
readOnly
onClick={()=>openPopup("custType","Customer Type",custTypes,false)}
 onKeyDown={e => handleKeyNavigation(e, "custType")}
      autoComplete="off"
/>

              <label>Pr List</label>
             <input
ref={el => inputsRef.current["prList"] = el}
value={form.prList}
placeholder="Select Price List"
readOnly
onClick={()=>openPopup("prList","Price List",prLists,false)}
 onKeyDown={e => handleKeyNavigation(e, "prList")}
      autoComplete="off"
/>
              <label>WhatsApp No</label>
              <input  ref={el => inputsRef.current["mobile"] = el}  name="mobile_unique_erp_016"value={form.mobile} onChange={e => updateField("mobile", e.target.value)}   onKeyDown={e => handleKeyNavigation(e, "mobile")} autoComplete="off"/>

              <label>Open Bal</label>
              <input  ref={el => inputsRef.current["openBal"] = el}  name="open_unique_erp_017"value={form.openBal} onChange={e => updateField("openBal", e.target.value)}   onKeyDown={e => handleKeyNavigation(e, "openBal")} autoComplete="off"/>

              <label>Credit Days</label>
              <input  ref={el => inputsRef.current["creditDays"] = el}  name="credit_days_unique_erp_018"value={form.creditDays} onChange={e => updateField("creditDays", e.target.value)}   onKeyDown={e => handleKeyNavigation(e, "creditDays")} autoComplete="off"/>

              <label>Credit Limit</label>
              <input  ref={el => inputsRef.current["creditLimit"] = el}  name="credit_limit_unique_erp_019"value={form.creditLimit} onChange={e => updateField("creditLimit", e.target.value)}   onKeyDown={e => handleKeyNavigation(e, "creditLimit")} autoComplete="off"/>
            
            </div>
           
            
          </div>
<div className="actions-compact">
  <button
    ref={newBtnRef}
    className="btn"
    onClick={onNew}
    onKeyDown={e => handleButtonNavigation(e, "new")}
  >
    NEW
  </button>

  <button
    ref={saveBtnRef}
    className="btn primary"
    onClick={onSave}
    onKeyDown={e => handleButtonNavigation(e, "save")}
  >
    SAVE
  </button>

  <button
    ref={updateBtnRef}
    className="btn"
    onClick={onUpdate}
    onKeyDown={e => handleButtonNavigation(e, "update")}
  >
    UPDATE
  </button>

  <button
    ref={deleteBtnRef}
    className="btn danger"
    onClick={onDelete}
    onKeyDown={e => handleButtonNavigation(e, "delete")}
  >
    DELETE
  </button>
</div>

        </div>

        {/* RIGHT LIST */}
        <div className="party-right">
          <label>Search</label>
          <input
            className="field search-field"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

          <div className="table-wrap-compact">
           <div className="table-body-compact">
  {[...filtered]
    .sort((a, b) =>
      a.partyName.localeCompare(b.partyName, undefined, { sensitivity: "base" })
    )
    .map((p, idx) => (
      <div
        key={p.id}
        className={"list-row" + (idx === selectedIndex ? " selected" : "")}
       onClick={() => { 
  setSelectedIndex(idx); 
  handleSelect(p);

  if (isMobile) {
    setMobileTab("entry");
  }
}}
      >
        <div className="row-left">
          <div className="name">{p.partyName}</div>
          <div className="place">{p.place}</div>
        </div>
        <div className="price">{p.mobileNo}</div>
      </div>
    ))}
</div>


          </div>
        </div>
      </div>
      {/* MOBILE FLOAT BUTTON */}
<button
  className="mobile-add-btn"
  onClick={openNewPartyMobile}
>
  +
</button>

{/* MOBILE BOTTOM NAV */}
<div className="mobile-bottom-nav">
  <button
    className={mobileTab === "list" ? "active" : ""}
    onClick={() => setMobileTab("list")}
  >
    Party List
  </button>

  <button
    className={mobileTab === "entry" ? "active" : ""}
    onClick={() => setMobileTab("entry")}
  >
    Entry
  </button>
</div>
{isMobile && (
  <button
    className="mobile-add-btn"
    onClick={() => setMobileTab("entry")}
  >
    +
  </button>
)}
{popup.open && (

<SelectPopup
title={popup.title}
options={popup.options}
allowAdd={popup.allowAdd}

value={form[popup.field]}

onSelect={(val)=>{

updateField(popup.field,val);

if(popup.field==="state"){
const code = stateCodes[val] || "";
if(code){
updateField("gstin",code);
}
}

}}

onClose={()=>setPopup({...popup,open:false})}

/>

)}
    </div>
  );
}
